// extracted by mini-css-extract-plugin
module.exports = {"location":"icon-row_location__A_bVo typography_bodyFont__Sn75r","pinIcon":"icon-row_pinIcon__LlGDU"};